import React, { useContext } from "react";
import { IXPModule } from "../interfaces/IXPModule";
import TwoLineCell from "./gridCells/TwoLineCell";
import RankChanger from "./RankChanger";
import { CharacterHistoryContext } from "../contexts/CharacterHistoryContext";
import { BonusBreakdownContext } from "../contexts/BonusBreakdownContext";
import SpendableImprovements from "./SpendableImprovements";
import { SpendingOnType } from "../interfaces/SpendablesForModules";

interface Props {
  xpModule: IXPModule;
}

export default ({ xpModule }: Props) => {
  const { updateRank } = useContext(CharacterHistoryContext);
  const { currentBonuses } = useContext(BonusBreakdownContext);

  return (
    <div className="grid-container grid-data-table grid-game-options">
      <TwoLineCell
        dataTest={`xp-desc-${xpModule.key}`}
        lineOne={xpModule.name}
        lineTwo={xpModule.key}
      />
      <RankChanger
        itemKey={xpModule.key}
        rank={
          currentBonuses[xpModule.key]
            ? currentBonuses[xpModule.key].actualBonus.current
            : xpModule.config.default
        }
        config={xpModule.config}
        onClick={(action) =>
          updateRank({
            updateRankAction: action,
            ruleItemConfig: xpModule.config,
          })
        }
      />
      <SpendableImprovements
        moduleKey={xpModule.key}
        spendingOn={SpendingOnType.XP}
      />
    </div>
  );
};
